import { ArrowRight, CheckCircle2 } from "lucide-react";
import { SectionEyebrow } from "@/components/Landing/primitives";

const BULLETS = Object.freeze([
    "All modules included in the platform fee.",
    "Subcontractor admins and their staff are licensed on a per-seat basis under the same model.",
    "SENTINEL Safety Intelligence included as standard.",
    "SSO, SCIM, audit logging, and Australian hosting included.",
]);

export default function Pricing({ onBook }) {
    return (
        <section
            id="pricing"
            className="relative py-24 sm:py-32 bg-white text-[#0A0A0A] border-t border-zinc-200"
        >
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 reveal">
                <SectionEyebrow>Pricing</SectionEyebrow>
                <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1] mt-3 max-w-3xl">
                    Enterprise pricing built around your project portfolio.
                </h2>

                <div className="mt-10 rounded-2xl border border-zinc-200 bg-[#F8FAFC] p-7 sm:p-9 grid md:grid-cols-3 gap-6 items-center">
                    <div className="md:col-span-2">
                        <p className="text-lg text-zinc-700 leading-relaxed">
                            Edara Software is priced{" "}
                            <span className="text-[#0A0A0A] font-semibold">
                                per-seat for every worker on the platform
                            </span>
                            . Tier 1 workforce and subcontractor staff are
                            licensed on the same basis. No surprise add-ons.
                        </p>
                        <ul className="mt-5 space-y-2.5 text-[14px] text-zinc-600">
                            {BULLETS.map((l) => (
                                <li
                                    key={l}
                                    className="flex items-start gap-2"
                                >
                                    <CheckCircle2 className="w-4 h-4 text-[#10B981] mt-1 shrink-0" />
                                    <span>{l}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:col-span-1">
                        <button
                            onClick={onBook}
                            className="w-full inline-flex items-center justify-center gap-2 px-5 py-4 rounded-lg bg-[#0A0A0A] text-white font-semibold hover:bg-[#1F2937]"
                            data-testid="pricing-cta"
                        >
                            Request a tailored quote
                            <ArrowRight className="w-4 h-4" />
                        </button>
                        <p className="mt-3 text-xs text-zinc-500 text-center">
                            Quotes turned around in days, not weeks.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
